import { render } from "./ArchivePage.vue?vue&type=template&id=5e5eb1c0&scoped=true&ts=true"
import script from "./ArchivePage.vue?vue&type=script&lang=ts"
export * from "./ArchivePage.vue?vue&type=script&lang=ts"

import "./ArchivePage.vue?vue&type=style&index=0&id=5e5eb1c0&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5eb1c0"]])

export default __exports__